// extracted by mini-css-extract-plugin
module.exports = {"container":"LogoLoader_container__mK__z","pulse":"LogoLoader_pulse__ZDEZv"};